import { query, type Cursor, type CursorPage } from './paging';

/** One reader event as GET /events lists it; `data` stays as the gateway sent it (MQTT contract). */
export interface ReaderEvent {
  id: string;
  gwId: string;
  site: string;
  epoch: string;
  seq: number;
  bootId: string;
  type: string;
  epc: string | null;
  tid: string | null;
  ts: string;
  receivedAt: string;
  clockOk: boolean | null;
  data: Record<string, unknown>;
  /** the registered cylinder with this EPC, if any */
  cylinderId: number | null;
  serialNo: string | null;
}
/** Reader events are keyed by their ULID. */
export type ReaderEventPage = CursorPage<ReaderEvent, string>;

/** One cylinder movement (a delivery note received, or a registration: no `from`). */
export interface Movement {
  id: number;
  at: string;
  gwId: string | null;
  shipmentId: number | null;
  shipmentNumber: string | null;
  cylinderId: number;
  serialNo: string;
  epc: string;
  fromLocationId: number | null;
  fromName: string | null;
  fromType: string | null;
  toLocationId: number | null;
  toName: string | null;
  toType: string | null;
}
export type MovementPage = CursorPage<Movement>;

/** `since` / `until`: ISO 8601 instants, since inclusive. */
export interface MovementFilter { locationId?: number; cylinderId?: number; provinceCode?: string; since?: string; until?: string }
export interface EventFilter { gwId?: string; epc?: string; type?: string; since?: string; until?: string }

export const eventPaths = {
  /** newest first; `beforeId` pages back */
  movements: (f: MovementFilter, limit: number, beforeId?: number) => `/movements${query({ ...f, limit, beforeId })}`,
  /** a keyset page in either direction (a location's movements, paged in a card) */
  movementsPage: (f: MovementFilter, cursor: Cursor, limit: number) => `/movements${query({ ...f, ...cursor, limit })}`,
  events: (f: EventFilter, limit: number, beforeId?: string) => `/events${query({ ...f, limit, beforeId })}`,
};
